/** Service Desk (M27) vocabulary: mirror of backend `app/core/constants/service_desk.py`.
 *  Generated once from the backend constants; `tests/core/test_service_desk_mirror.py` keeps the two equal. */

export const SERVICE_DESK_FLAG = "service_desk" as const;

export const SERVICE_NAV_GROUP_LABEL = "Service" as const;

export const SERVICE_FEATURE_NAME = "Service Desk" as const;

export const TICKET_PRIORITY_VALUES = ["low", "normal", "high", "urgent"] as const;
export type TicketPriority = (typeof TICKET_PRIORITY_VALUES)[number];

export const STATUS_CATEGORY_VALUES = ["new", "open", "pending", "on_hold", "resolved", "closed"] as const;
export type StatusCategory = (typeof STATUS_CATEGORY_VALUES)[number];

export const TICKET_CATEGORY_TRANSITIONS = {
  new: ["closed", "on_hold", "open", "pending", "resolved"],
  open: ["closed", "on_hold", "pending", "resolved"],
  pending: ["closed", "on_hold", "open", "resolved"],
  on_hold: ["closed", "open", "pending", "resolved"],
  resolved: ["closed", "open"],
  closed: [],
} as const;

export const CLIENT_OPEN_CATEGORIES = ["new", "open", "pending", "on_hold", "resolved"] as const;

export const TYPE_CATEGORY_VALUES = ["customer", "back_office", "tracker"] as const;
export type TypeCategory = (typeof TYPE_CATEGORY_VALUES)[number];

export const REQUIRES_ASSET_VALUES = ["no", "optional", "required"] as const;
export type RequiresAsset = (typeof REQUIRES_ASSET_VALUES)[number];

export const TYPE_STATUS_VALUES = ["active", "archived"] as const;
export type TypeStatus = (typeof TYPE_STATUS_VALUES)[number];

export const FIELD_TYPE_VALUES = [
  "text",
  "long_text",
  "number",
  "integer",
  "bool",
  "date",
  "datetime",
  "dropdown",
  "multi_select",
  "asset",
  "site",
  "order",
  "contact",
  "files",
  "serial",
] as const;
export type FieldType = (typeof FIELD_TYPE_VALUES)[number];

export const FIELD_REQUIRED_ON_VALUES = ["create", "resolve"] as const;
export type FieldRequiredOn = (typeof FIELD_REQUIRED_ON_VALUES)[number];

export const CONDITION_PARENT_TYPES = ["dropdown", "bool"] as const;

export const MESSAGE_KIND_VALUES = ["public", "internal", "system", "ai_summary"] as const;
export type MessageKind = (typeof MESSAGE_KIND_VALUES)[number];

export const TICKET_ORIGIN_VALUES = ["ai_intake", "client_form", "staff", "email", "api", "workflow", "conversation", "handoff", "order_issue", "visit", "punch_list", "pm_plan"] as const;
export type TicketOrigin = (typeof TICKET_ORIGIN_VALUES)[number];

export const TICKET_CHANNEL_VALUES = ["widget", "webapp", "mobile", "messenger", "email", "api", "console"] as const;
export type TicketChannel = (typeof TICKET_CHANNEL_VALUES)[number];

export const TICKET_LINK_KIND_VALUES = ["related_to", "duplicate_of", "caused_by", "blocks", "blocked_by", "follow_up_of"] as const;
export type TicketLinkKind = (typeof TICKET_LINK_KIND_VALUES)[number];

export const ASSIGNMENT_METHOD_VALUES = ["round_robin", "least_open", "skills_match", "none", "user"] as const;
export type AssignmentMethod = (typeof ASSIGNMENT_METHOD_VALUES)[number];

export const SLA_SCOPE_VALUES = ["conversation", "ticket"] as const;
export type SlaScope = (typeof SLA_SCOPE_VALUES)[number];

export const SLA_METRIC_VALUES = ["first_response", "next_response", "resolution", "onsite_response"] as const;
export type SlaMetric = (typeof SLA_METRIC_VALUES)[number];

export const SLA_STATE_VALUES = ["ok", "warning", "breached", "met", "paused", "n/a"] as const;
export type SlaState = (typeof SLA_STATE_VALUES)[number];

export const SLA_PRECEDENCE = ["asset_contract", "organisation_contract", "ticket_type", "workspace_default"] as const;

export const SLA_WARN_AT_PERCENT_DEFAULT = 75 as const;

export const SLA_TONE_WARNING_BELOW_PERCENT = 60 as const;

export const SLA_TONE_DANGER_BELOW_PERCENT = 35 as const;

export const SLA_TICK_SECONDS = 60 as const;

export const DEFAULT_CALENDAR_TIMEZONE = "Asia/Manila" as const;

export const ORGANISATION_KIND_VALUES = ["customer", "prospect", "partner", "internal"] as const;
export type OrganisationKind = (typeof ORGANISATION_KIND_VALUES)[number];

export const AUTO_JOIN_MODE_VALUES = ["off", "as_user", "pending_approval"] as const;
export type AutoJoinMode = (typeof AUTO_JOIN_MODE_VALUES)[number];

export const ORGANISATION_STATUS_VALUES = ["active", "on_hold", "archived"] as const;
export type OrganisationStatus = (typeof ORGANISATION_STATUS_VALUES)[number];

export const ORG_ROLE_VALUES = ["org_admin", "member"] as const;
export type OrgRole = (typeof ORG_ROLE_VALUES)[number];

export const CONTACT_VISIBILITY_VALUES = ["own", "organisation"] as const;
export type ContactVisibility = (typeof CONTACT_VISIBILITY_VALUES)[number];

export const VERIFIED_VIA_VALUES = ["widget_jwt", "email_otp", "magic_link", "staff_verified"] as const;
export type VerifiedVia = (typeof VERIFIED_VIA_VALUES)[number];

export const CONTACT_STATUS_VALUES = ["active", "pending_approval", "blocked", "archived"] as const;
export type ContactStatus = (typeof CONTACT_STATUS_VALUES)[number];

export const CONTACT_LANGUAGE_VALUES = ["en", "fil"] as const;
export type ContactLanguage = (typeof CONTACT_LANGUAGE_VALUES)[number];

export const DEFAULT_CONTACT_VISIBILITY = "own" as const;

export const DEFAULT_AUTO_JOIN = "pending_approval" as const;

export const SERVICE_NOTIFICATION_TYPES = [
  "ticket_new",
  "ticket_assigned",
  "ticket_client_replied",
  "ticket_mention",
  "ticket_sla",
  "ticket_csat_low",
  "ticket_returned_to_queue",
  "order_placed",
  "order_issue",
  "order_sync_failed",
  "order_approval",
  "visit_scheduled",
  "visit_changed",
  "asset_due",
  "connector_health",
] as const;

export const SERVICE_RATE_BUCKET_VALUES = [
  "service_ticket_contact_hour",
  "service_ticket_contact_day",
  "service_ticket_guest_ip_hour",
  "service_ticket_tenant_hour",
  "service_ticket_organisation_hour",
  "service_reply_contact_hour",
] as const;
export type ServiceRateBucket = (typeof SERVICE_RATE_BUCKET_VALUES)[number];

export const SERVICE_RATE_LIMITS = {
  service_ticket_contact_hour: { capacity: 10, windowSeconds: 3600 },
  service_ticket_contact_day: { capacity: 30, windowSeconds: 86400 },
  service_ticket_guest_ip_hour: { capacity: 3, windowSeconds: 3600 },
  service_ticket_tenant_hour: { capacity: 600, windowSeconds: 3600 },
  service_ticket_organisation_hour: { capacity: 100, windowSeconds: 3600 },
  service_reply_contact_hour: { capacity: 60, windowSeconds: 3600 },
} as const;

export const RATE_ALERT_INTERVAL_SECONDS = 3600 as const;

export const SERVICE_ERROR_CODE_VALUES = [
  "organisation_exists",
  "public_domain",
  "type_in_use",
  "fields_required",
  "invalid_transition",
  "merge_other_org",
  "participant_other_org",
  "ticket_changed",
  "idempotency_mismatch",
  "bot_check_failed",
  "stage_blocked",
] as const;
export type ServiceErrorCode = (typeof SERVICE_ERROR_CODE_VALUES)[number];
